import { render, staticRenderFns } from "./download-list.vue?vue&type=template&id=9234e712&scoped=true"
import script from "./download-list.vue?vue&type=script&lang=js"
export * from "./download-list.vue?vue&type=script&lang=js"
import style0 from "./download-list.vue?vue&type=style&index=0&id=9234e712&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9234e712",
  null
  
)

export default component.exports